import cs from "classnames";
import React from "react";

import "./RadioGroup.css";

interface RadioGroupProps {
	direction?: "horizontal" | "vertical";
	columns?: number; // vertical only
}

export const RadioGroup: React.FunctionComponent<
	React.PropsWithChildren<RadioGroupProps>
> = ({ direction = "horizontal", columns = 1, children }) => (
	<div
		className={cs(
			"radio-group",
			`radio-group--${direction}`,
			`radio-group--${columns}`
		)}
	>
		{children}
	</div>
);

export const RadioGroupColumn: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="radio-group__column">{children}</div>;
